export const MATCH_TYPE_LIKE = 'LIKE';
export const MATCH_TYPE_EXACT = 'EXACT';
export const MATCH_TYPE_BOOL = 'BOOL';
export const MATCH_TYPE_IN = 'IN';
export const MATCH_TYPE_RELATION = 'RELATION';
export const MATCH_TYPE_NULL = 'NULL';
export const MATCH_TYPE_DATE = 'DATE';
export const MATCH_TYPE_RAW_DQL = 'RAW';
